/* import __COLOCATED_TEMPLATE__ from './tour-inserter.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class TourInserter extends Component {
  @action
  insertMessengerCard(cardJSON) {
    this.args.inserterApi.createBlock('messengerCard', cardJSON);
  }

  closePopover() {}
}
